<div class="container">
  <div class="box">
    <div class="myForm">
      <div class="card">
        <h4 class="card-header">Upload Documents For Collaterals and Reports</h4>
        <div class="card-body scroll">
          <form [formGroup]="collateralsForm" (ngSubmit)="onUpload()">
            <div style="display: flex; justify-content: space-around; align-items: center;">
              <div class="p-2">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>Client</mat-label>
                  <mat-select formControlName="client" placeholder="Client">
                    <mat-option *ngFor="let item of clients" [value]="item.id">{{ item.dname }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('client').hasError('required')">*Client is
                    required</mat-error>
                </mat-form-field>
              </div>
              <div class="p-2">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>To</mat-label>
                  <mat-select formControlName="to" placeholder="To">
                    <mat-option *ngFor="let item of dropdownOptions.to" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('to')?.hasError('required')">*To is required</mat-error>
                </mat-form-field>
              </div>
              <div class="p-2">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>Doc Type</mat-label>
                  <mat-select formControlName="docType" placeholder="Doc Type">
                    <mat-option *ngFor="let item of dropdownOptions.docType" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('docType')?.hasError('required')">*Doc Type is
                    required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="filename">
              <div class="p-2">
                <mat-form-field appearance="outline" color="primary" style="width:100%">
                  <mat-label>File Name</mat-label>
                  <input matInput type="text" name="filename" formControlName="filename" maxlength="150" required />
                  <mat-error *ngIf="collateralsForm.get('filename')?.hasError('required')">*File Name is
                    required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div style="display: flex; justify-content: space-around; align-items: center;">
              <div class="p-2" *ngIf="collateralsForm.get('docType')?.value !== 'Collaterals'">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>year</mat-label>
                  <mat-select formControlName="year" placeholder="Year">
                    <mat-option *ngFor="let item of dropdownOptions.year" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('year').hasError('required')">*Year is
                    required</mat-error>
                </mat-form-field>
              </div>
              <div class="p-2" *ngIf="collateralsForm.get('docType')?.value !== 'Collaterals'">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>Report Type</mat-label>
                  <mat-select formControlName="reportType" placeholder="Report Type">
                    <mat-option *ngFor="let item of dropdownOptions.reportType" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('reportType').hasError('required')">*Report Type is
                    required</mat-error>
                </mat-form-field>
              </div>
              <div class="p-2"
                *ngIf="collateralsForm.get('docType')?.value !== 'Collaterals' && shouldShowReportPeriod()">
                <mat-form-field appearance="outline" color="primary">
                  <mat-label>Report Period</mat-label>
                  <mat-select formControlName="reportPeriod" placeholder="Report Period">
                    <mat-option *ngFor="let item of dropdownOptions.reportPeriod" [value]="item">{{ item }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="collateralsForm.get('reportPeriod').hasError('required')">*Report Period is
                    required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div style="display: flex; justify-content: space-around; align-items: center;">
              <p>
                <button class="button" color="primary" type="button" mat-raised-button (click)="fileInput.click()"
                  required>
                  <mat-icon>attachment</mat-icon>
                  File Upload*
                </button>
                <input hidden #fileInput name="xl" type="file"
                  accept=".jpg, .jpeg, .png, .gif, .mp4, .pdf, .doc, .docx, .xls, .xlsx" formControlName="uploadedFile"
                  (change)="onFileSelected($event)" required />
              </p>
              <p>
                <button class="button" color="primary" type="submit" mat-raised-button required>
                  <mat-icon>cloud_upload</mat-icon>
                  Upload
                </button>
              </p>
            </div>
            <span *ngIf="selectedFile" class="filenameupload">
              <b>{{ selectedFile?.name }}</b>
              <button color="primary" class="remove" mat-button (click)="removeFile()">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </span>
          </form>
        </div>
        <div class="info">
          <p>Accepts jpg, jpeg, png, gif, mp4, pdf, doc, docx, xls and xlsx formats of 50MB Maximum</p>
        </div>
      </div>
    </div>
  </div>
</div>